class Menu {

	constructor($target) {
		
		//Private properties
        $target;
		let name = "HELLO";
		var navWrapper = $target.find(".nav");
		var hamburger = $target.find("#hamburger");
		var menu = $target.find("#menu-main-menu");
		var subMenu = $target.find('.menu-item-has-children');	
		var menuLeft = $target.find('.top_nav_container__logo');
		var menuRight = $target.find('.top_nav_container__right_container');
		var bgBody = document.createElement('div');	
		var bgMenu = document.createElement('div');	
		var subMenuList = $target.find(".sub-menu li");
		var mobileSearch = $target.find(".top_nav_container__mobile_search_container");
		var isiPad = navigator.userAgent.match(/iPad/i) != null;
	
		function init(){
			addEventListeners(); 
			addClassFunc();
		}

		function addEventListeners(){
			//click the menu
			$(hamburger).click(toggleMenu);
			$(window).resize(resize);
			$(window).scroll(resize);
				
		}

		function addClassFunc(){
			$(subMenuList).addClass("sub-menu__item");
		}

		// changes menu display dending on width of screen
		function resize(){
			if($(hamburger).hasClass('closed') && $(window).width() >= 977){
				$(menu).css('display', 'flex');
				$(hamburger).removeClass('open');
				$(menuLeft).css('display', 'block');
				$(menuRight).css('display', 'flex');
			} else{
				$(hamburger).removeClass('open');
				$(menu).css('display', 'none');
				$(bgBody).remove();
				$(hamburger).css('margin-right', '0%');
				$(menuLeft).css('display', 'block');
				$(menuRight).css('display', 'flex');
				$(mobileSearch).css('display', 'none');
			}
		}

		// toggling hamburger menu
		function toggleMenu(){
			$(hamburger).toggleClass('open');
			$(bgBody).addClass('overlay');
			
			if($(hamburger).hasClass('open')){
				showOverlay();
				$(menu).css('display', 'block');	
				$(bgBody).appendTo('body');	
				
				$(menuLeft).css('display', 'none');
				$(menuRight).css('display', 'none');

				$(mobileSearch).css('display', 'block');

				navWrapper.addClass('nav--open')
				navWrapper.removeClass('nav--closed')


				if($(window).width() < 768){
					$(hamburger).css('margin-right', '-145%');
				} else{
					$(hamburger).css('margin-right', '-50%');
				}

			}else{
				$(bgBody).remove();
				$(menu).css('display', 'none');
				$(hamburger).css('margin-right', '0%');
				$(menuLeft).css('display', 'block');
				$(menuRight).css('display', 'flex');
				$(mobileSearch).css('display', 'none');

				navWrapper.removeClass('nav--open');
				navWrapper.addClass('nav--closed');
				
			}
		}
		// functions for the overlay for main menu
		function showOverlay(){
			//append the overlay on the body to cover all the page 
		   	$(bgBody).appendTo('body');
		   	$(bgBody).click(hideOverlay);
		}

		function hideOverlay(){
			//if you click on the overlay close the menu and show the hidden elements
		   	$('body').css('overflow', 'auto');
		   	$(bgBody).remove();
		   	$(hamburger).removeClass('open');
			$(menu).css('display', 'none');
			$(menuLeft).css('display', 'block');
			$(menuRight).css('display', 'flex');
			$(hamburger).css('margin-right', '0%');
			$(mobileSearch).css('display', 'none');
			
		}

		// displays the sub menu items 
		
		var windowSize = window.matchMedia("(max-width: 991px)");
		displaySubMenu(windowSize);
		windowSize.addListener(displaySubMenu); 

		function displaySubMenu(windowSize) {

			function displaySubMenuList(){
				
				var subList = $(this).find('.sub-menu');
				$(subList).toggleClass('displayList');
				
				if($(subList).hasClass('displayList')){
					$(subList).css('display', 'block');

					if(isiPad == true && window.innerHeight < window.innerWidth){
						showMenuOverlay();
						$(bgMenu).appendTo('body');
						$(bgMenu).addClass('menuBg');
					}
				}
				else{
					$(subList).css('display', 'none');
					if(isiPad == true && window.innerHeight < window.innerWidth){
						$(bgMenu).remove();
					}
				}
				
				function showMenuOverlay(){
					//append the overlay on the body to cover all the page 
					$(bgMenu).appendTo('body');
					$(bgMenu).click(hideMenuOverlay);
				}
		
				function hideMenuOverlay(){
					//if you click on the overlay close the menu
					$('body').css('overflow', 'auto');
					$(bgMenu).remove();
					$(subList).removeClass('displayList')
					$(subList).css('display', 'none');
					
				}

				function resizeSubMenu(){
					if($(subList).hasClass('displayList')){
						$(subList).css('display', 'none');
						$(subList).removeClass('displayList');	
					}
				}
		
				$(window).resize(resizeSubMenu);

			}

			if(isiPad == true){
				$(subMenu).bind("click",displaySubMenuList);
			}else{
				if (windowSize.matches) {  
					$(subMenu).bind("click",displaySubMenuList);
					$(subMenu).off( "mouseenter mouseleave" );
				} else {	
					$(subMenu).hover(displaySubMenuList);
					$(subMenu).unbind( "click" );		
				}
			}
		}

		init();
		return {

			//Public properties
			name:name,

			publicBlockHero:function(string){

				// $target.append("HELLO!"+string);
				// console.log(name)
				// console.log(string)
				// console.log($target)

			}

		}

	}

}

export default Menu;